/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

export default {
  setBoutiques (state, boutiques) {
    state.boutiques = boutiques
  },
  setBoutique (state, boutique) {
    state.boutique = boutique
  },
  setActiveBoutique (state, boutique) {
    state.activeBoutique = boutique
  },
  setOpenFindInStore (state, boolean) {
    state.openFindInBoutiue = boolean
  },
  setStoresByProduct (state, stores) {
    state.storesByProduct = stores
  },
  updateCurrentBoutique (state, valueToOverride) {
    state.boutique = { ...state.boutique, ...valueToOverride }
  }
}
